module.exports = __webpack_public_path__ + "static/media/image_Frame8578.d25f7699.png";